import { Text } from '@/components/ui/text'
import { Image, View } from 'react-native'

type EmptyStateIllustrationProps = {
  message: string
}

export default function EmptyStateIllustration({ message }: EmptyStateIllustrationProps) {
  return (
    <View className="items-center" style={{ transform: [{ translateY: -28 }] }}>
      <Image
        source={require('@/assets/images/no_result.png')}
        style={{ width: 200, height: 200, marginBottom: 16 }}
        resizeMode="contain"
      />
      <Text className="text-secondary-label text-base text-center px-6">{message}</Text>
    </View>
  )
}
